import { render } from "./GraficoCustoPorProjeto.vue?vue&type=template&id=5e47c8a5&scoped=true"
import script from "./GraficoCustoPorProjeto.vue?vue&type=script&lang=js"
export * from "./GraficoCustoPorProjeto.vue?vue&type=script&lang=js"

import "./GraficoCustoPorProjeto.vue?vue&type=style&index=0&id=5e47c8a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e47c8a5"]])

export default __exports__